import React, { Fragment } from 'react';
import {
  Box,
  Divider,
  Stack,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

import TrackedItem from './TrackedItem';
import { useApplicationStatusTracker } from './hooks';
import NotesSection from './NotesSection';

export default function LeaseApplicationStatusTracker({
  application,
  householdId,
  providerPropertyProfiles,
  handleNotesChange,
  organizationId,
  propertyId,
  property,
  checkUserPermissions,
  applicationUpdating,
  isResident = false,
  applicationStatusChangeHandler,
  applicationStatuses,
  handleStatusChange,
  waitlistModalProps,
  leaseExecuted,
  leaseSentToPortal,
  headOfHouseholdId,
  affordableWaitlistRecord,
  applicationStatusId,
  floorPlans,
  refreshApplication,
}) {
  const {
    items,
    showWaitlistForm,
    waitlistSectionProps,
    prospectUpdateAllowed,
    applicationReceivedEditAllowed,
    applicationStatusUpdateAllowed,
    localWaitlistInfo,
    waitlistActions,
    isLoading,
  } = useApplicationStatusTracker({
    application,
    householdId,
    providerPropertyProfiles,
    property,
    organizationId,
    propertyId,
    checkUserPermissions,
    isResident,
  });

  return (
    <Stack mb={3}>
      <Box
        sx={{
          backgroundColor: 'background.alt',
        }}
        mb={3}
      >
        <Stack
          direction="row"
          borderRadius="4px"
          border="1px solid"
          borderColor="divider"
          alignItems="stretch"
          py={3}
        >
          {items.map((item, index) => {
            return (
              <Fragment key={item.name}>
                {index !== 0 && (
                  <Divider orientation="vertical" variant="middle" flexItem />
                )}
                <TrackedItem
                  item={item.name}
                  status={item.status}
                  data={item.data}
                  applicationReceivedEditAllowed={
                    applicationReceivedEditAllowed
                  }
                  applicationStatusChangeHandler={
                    applicationStatusChangeHandler
                  }
                  applicationStatuses={applicationStatuses}
                  handleStatusChange={handleStatusChange}
                  application={application}
                  waitlistModalProps={waitlistModalProps}
                  applicationStatusUpdateAllowed={
                    applicationStatusUpdateAllowed
                  }
                  leaseExecuted={leaseExecuted}
                  leaseSentToPortal={leaseSentToPortal}
                  isResident={isResident}
                  headOfHouseholdId={headOfHouseholdId}
                  affordableWaitlistRecord={affordableWaitlistRecord}
                  applicationStatusId={applicationStatusId}
                  floorPlans={floorPlans}
                  localWaitlistInfo={localWaitlistInfo}
                  waitlistActions={waitlistActions}
                  organizationId={organizationId}
                  propertyId={propertyId}
                  refreshApplication={refreshApplication}
                />
              </Fragment>
            );
          })}
        </Stack>
      </Box>

      <NotesSection
        showWaitlistSection={showWaitlistForm}
        waitlistSectionProps={waitlistSectionProps}
        applicationNotes={application?.notes}
        prospectUpdateAllowed={prospectUpdateAllowed}
        handleApplicationNotesChange={handleNotesChange}
        applicationId={application?.id}
        applicationUpdating={applicationUpdating}
        isResident={isResident}
        isLoading={isLoading}
      />
    </Stack>
  );
}
